import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { generateAndCachePwaIcons } from './utils/generatePwaIcons'

// Register Service Worker for PWA support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => {
        // Check for updates every 60 seconds
        setInterval(() => registration.update(), 60000);

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              console.info('[SW] New version available. Refresh to update.');
            }
          });
        });
      })
      .catch((err) => {
        console.warn('[SW] Registration failed:', err);
      });
  });
}

// Generate and cache PNG icons for Lighthouse PWA installability
generateAndCachePwaIcons();

// Capture the beforeinstallprompt event so we can trigger it later
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  (window as any).__deferredInstallPrompt = e;
  window.dispatchEvent(new CustomEvent('pwa-installable', { detail: e }));
});

window.addEventListener('appinstalled', () => {
  (window as any).__deferredInstallPrompt = null;
  console.info('[PWA] App installed successfully.');
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
